import DeviceAliasAutoComplete from './device-alias-autocomplete';
export default DeviceAliasAutoComplete;